var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_3410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.49 14C13.8719 14 16.6091 11.2602 16.6091 7.875C16.6091 4.48984 13.8719 1.75 10.49 1.75C7.10804 1.75 4.37081 4.48984 4.37081 7.875C4.37081 11.2602 7.10804 14 10.49 14ZM14.6859 15.75H14.2325C13.096 16.2969 11.834 16.625 10.49 16.625C9.14593 16.625 7.88932 16.2969 6.74744 15.75H6.29397C2.81917 15.75 0 18.5719 0 22.05V23.625C0 25.0742 1.17466 26.25 2.62249 26.25H18.3574C19.8052 26.25 20.9799 25.0742 20.9799 23.625V22.05C20.9799 18.5719 18.1607 15.75 14.6859 15.75ZM26.2249 14C29.1205 14 31.4699 11.6484 31.4699 8.75C31.4699 5.85156 29.1205 3.5 26.2249 3.5C23.3292 3.5 20.9799 5.85156 20.9799 8.75C20.9799 11.6484 23.3292 14 26.2249 14ZM28.8474 15.75H28.6398C27.8803 16.0125 27.0772 16.1875 26.2249 16.1875C25.3726 16.1875 24.5694 16.0125 23.81 15.75H23.6024C22.4878 15.75 21.4607 16.0727 20.5592 16.5922C21.8923 18.0305 22.7282 19.9391 22.7282 22.05V24.15C22.7282 24.2703 22.7009 24.3852 22.6954 24.5H32.344C33.7919 24.5 34.9665 23.3242 34.9665 21.875C34.9665 18.4898 32.2293 15.75 28.8474 15.75Z",
    fill: "#796DEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_3410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9665,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.2b5319bd11cf8d10f64d81e037464245.svg";
export { ForwardRef as ReactComponent };